import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { EntityLabelList } from '../../../Entity'
import { EntityExtraTags } from '../../../EntityExtraTags'
import { FloatingTooltip } from '../../../Floating'
import { isRequestTable } from '../../Table.utils'
import { TableCellNote } from '../../TableCellNote'
import { TableCellText } from '../../TableCellText'
import { TableCellBase } from '../TableCellBase'

import * as styles from './TableTitleCell.module.css'

import BuildingIcon from '../../../../icons/building.svg'
import ServiceRequestIcon from '../../../../icons/service-request.svg'

function TableTitleCell({
  AdditionalIcon,
  Icon,
  TextArchivedIcon,
  additionalIconProps,
  additionalTooltipInfo,
  avatarProps: {
    Icon: AvatarIcon,
    className: avatarClassName = styles.avatar,
    size: avatarSize = AVATAR_HEIGHT_24,
    ...avatarProps
  } = EMPTY_OBJECT,
  context,
  done,
  extra,
  extraRules,
  iconTooltip,
  id,
  isShort,
  labels,
  noteProps,
  showIconTooltip,
  tagsInteractable = true,
  tagsProps,
  textArchivedIconProps,
  textClassName,
  tooltip,
  unread,
  value,
  onClickDocFlowTag,
  onClickEmailTag,
  onClickFileTag,
  onClickRequestTag,
  ...cellProps
}) {
  const withAdditionalInfo = (extra && !isShort) || !!noteProps?.value

  const CellIcon =
    AvatarIcon ??
    (isRequestTable(context) || !value ? ServiceRequestIcon : BuildingIcon)

  const additionalInfoContainerClassName = classNames(
    styles.additionalInfoContainer,
    { [styles.withNote]: !!noteProps?.value }
  )

  return (
    <TableCellBase {...cellProps} isShort={isShort}>
      {Icon ? <Icon /> : null}
      {!Icon && (CellIcon || !!avatarProps) ? (
        <FloatingTooltip content={iconTooltip} disabled={!showIconTooltip}>
          <Avatar
            {...avatarProps}
            Icon={CellIcon}
            className={avatarClassName}
            size={avatarSize}
          />
        </FloatingTooltip>
      ) : null}
      <div className={styles.title}>
        <TableCellText
          AdditionalIcon={AdditionalIcon}
          ArchivedIcon={TextArchivedIcon}
          additionalIconProps={additionalIconProps}
          additionalInfo={additionalTooltipInfo}
          archivedIconProps={textArchivedIconProps}
          className={textClassName}
          done={done}
          tooltip={tooltip}
          unread={unread}
          value={value}
        />

        <EntityLabelList labels={labels} />

        {withAdditionalInfo ? (
          <div className={additionalInfoContainerClassName}>
            {noteProps?.value ? <TableCellNote {...noteProps} /> : null}
            {isShort ? null : (
              <EntityExtraTags
                {...tagsProps}
                {...(tagsInteractable
                  ? {
                      onClickDocFlowTag,
                      onClickEmailTag,
                      onClickFileTag,
                      onClickRequestTag,
                    }
                  : null)}
                extra={extra}
                id={id}
                interactable={tagsInteractable}
                rules={extraRules}
              />
            )}
          </div>
        ) : null}
      </div>
    </TableCellBase>
  )
}

export default TableTitleCell
